var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundBlueberrymin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1435,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576.721 328.987C482.88 238.774 410.096 126.87 366.393 1.324h-511.875c71.858 123.4 113.07 266.877 113.07 419.994 0 349.567-214.618 648.942-519.238 773.722v237.9H487.065c-104.859-139.66-166.996-313.23-166.996-501.336 0-236.761 98.476-450.506 256.652-602.591v-.026z",
    fill: "url(#prefix__paint0_linear_2197_37679)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M576.722 328.987C726.952 184.557 931.03 95.774 1155.87 95.774c224.84 0 428.92 88.809 579.15 233.213 93.84-90.213 166.63-202.117 210.33-327.663H366.367C410.07 126.87 482.881 238.801 576.695 328.987h.027z",
    fill: "url(#prefix__paint1_linear_2197_37679)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1735.02 328.987c-150.23 144.43-354.31 233.212-579.15 233.212-224.84 0-428.918-88.809-579.148-233.212-158.203 152.084-256.653 365.829-256.653 602.591 0 188.082 62.137 361.642 166.996 501.332H1824.71c98.92-131.74 159.76-293.68 166.33-469.496v-63.62c-8.4-224.048-104.94-425.556-255.99-570.781l-.03-.026z",
    fill: "url(#prefix__paint2_linear_2197_37679)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M576.721 328.987C726.952 473.417 931.029 562.2 1155.87 562.2c224.84 0 428.92-88.809 579.15-233.213-150.23-144.43-354.31-233.212-579.15-233.212-224.841 0-428.918 88.809-579.149 233.212z",
    fill: "url(#prefix__paint3_linear_2197_37679)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_2197_37679",
    x1: -2397.21,
    y1: 456.408,
    x2: 1063,
    y2: 456.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#C31A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#933FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_2197_37679",
    x1: 813.571,
    y1: 2711.91,
    x2: 2373.85,
    y2: -753.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#C31A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#933FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear_2197_37679",
    x1: 1208.95,
    y1: 265.354,
    x2: 1208.95,
    y2: 1740.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#C31A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#00ADEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear_2197_37679",
    x1: 1386.73,
    y1: -541.321,
    x2: 866.641,
    y2: 679.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#C31A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#933FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#00ADEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundBlueberrymin);
export default __webpack_public_path__ + "static/media/background-blueberry.min.df112fbd939c56d30a871782623fddbc.svg";
export { ForwardRef as ReactComponent };